import React from "react";

type Props = {
  backgroundColor: string;
  title: string;
  list: string[];
  Button: React.ReactNode;
  ButtonCancel?: React.ReactNode;
};

const Alert: React.FC<Props> = ({
  backgroundColor,
  title,
  list,
  Button,
  ButtonCancel,
}) => {
  return (
    <div className="shadow sm:rounded-xl sm:overflow-hidden max-w-[625px] text-white mb-6">
      <div
        className={`rounded-xl border border-gray-300 p-6 ${backgroundColor}`}
      >
        <p className="text-sm">{title}</p>
        <ul
          className="mt-2 ml-2 list-inside list-disc text-sm"
          style={{ listStyleType: "none" }}
        >
          {list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        {Button}
        {ButtonCancel}
      </div>
    </div>
  );
};

export default Alert;
